import axios from "axios";

export interface CmsChartData {
  comparison_chart: {
    uuid: string;
    title: string;
    header: string;
    header_font?: string;
    header_text_color: string;
    instructions_copy: string;
    instructions_copy_text_font?: string;
    instructions_copy_text_color: string;
    legal_copy?: string;
    legal_footer_text_color?: string;
    // --> background_color
    desktop_column_color?: string;
    // X shop_button_text_primary_border_color?: string;
    shop_select_button_primary_color?: string;
    shop_select_button_primary_border_color?: string;
    shop_select_button_hover_border_color?: string;
    shop_select_button_hover_color?: string;
    shop_select_button_text_primary_color?: string;
    shop_select_button_text_hover_color?: string;
    products: CmsProduct[];
    // -- Carousel
    carousel_text_color?: string;
    carouser_font?: string;
    selected_product_color?: string;
    filter_button_font?: string;
    filter_button_background_color?: string;
    filter_button_outline_color?: string;
    filter_button_text_color?: string;
    filter_button_selected_background_color?: string;
    filter_button_selected_text_color?: string;
    show_additional_filter_button: boolean;
    additional_filter_button_copy?: string;
    additional_filter_button_background_color?: string;
    additional_filter_button_outline_color?: string;
    additional_filter_button_text_color?: string;
    use_custom_product_filters: boolean;
    chart_carousel_sections: CmsChartCarouselSection[];
    // -- Mobile Carousel
    more_products_button_copy: string;
    more_products_button_text_color?: string;
    more_products_button_color?: string;
    product_pop_up_background_color?: string;
    product_popup_footer_background_color?: string;
    product_text_color?: string;
    product_selected_text_color?: string;
    product_selected_state_color?: string;
    product_additional_filter_button_text_color?: string;
    product_additional_filter_button_color?: string;
    close_product_pop_up_button_copy: string;
    close_product_pop_up_button_text_color?: string;
    close_product_pop_up_button_color?: string;
    //-- Chart
    column_background_color?: string;
    bundle_secondary_column_background_color?: string;
    tag_font?: string;
    show_shop_buttons: boolean;
    shop_button_copy?: string;
    shop_button_primary_color?: string;
    shop_button_primary_border_color?: string;
    shop_button_text_primary_color?: string;
    shop_button_text_hover_color?: string;
    shop_button_hover_color?: string;
    shop_button_hover_border_color?: string;
    show_product_application: boolean;
    product_application_title?: string;
    product_application_title_font?: string;
    product_application_title_text_color?: string;
    show_best_for_section: boolean;
    best_for_section_title?: string;
    best_for_section_title_font?: string;
    best_for_section_title_text_color?: string;
    best_for_section_icon_color?: string;
    best_for_section_hover_icon_color?: string;
    product_application_description_font?: string;
    product_application_description_text_color?: string;
    show_price: boolean;
    show_shop_select_section: boolean;
    shop_select_title?: string;
    shop_select_title_font?: string;
    shop_select_title_text_color?: string;
    shop_select_mobile_title_text_color?: string;
    shop_select_mobile_title_row_color?: string;
    shop_select_description?: string;
    shop_select_description_font?: string;
    shop_select_description_text_color?: string;
    open_on_load: boolean;
    sections: CmsSection[];
    //-- Stats
    show_stats_sections: true;
    stats_section_background_color?: string;
    stats_sections?: CmsStatSection[];
    //-- Footer
    show_footer_section: true;
    footer_background_color?: string;
    footer_title: string;
    footer_title_font?: string;
    footer_title_text_color?: string;
    footers: CmsFooter[];
  };
  additional_filter_link?: string;
  labels: CmsLabel[];
}

export interface CmsBestForIcon {
  uuid: string;
  best_for_icon: {
    icon_url: string;
    copy: string;
  };
}

export interface CmsProductBase {
  uuid: string;
  image_url: string;
  product_features: CmsProductFeature[];
}

export interface CmsProduct extends CmsProductBase {
  name: string;
  sku?: string;
  explore_sku?: string;
  mobile_preselected: boolean;
  desktop_preselected: boolean;
  product_kind: {
    uuid: string;
  };
  use_tag: boolean;
  tag_name?: string;
  tag_text_color?: string;
  tag_background_color?: string;
  price?: string;
  sales_price?: string;
  use_sales_message: boolean;
  sales_message?: string;
  sales_message_text_color?: string;
  sales_message_text_font?: string;
  application?: string;
  product_best_for_icons?: [CmsBestForIcon];
  overview?: string;
  link?: string;
  show_shop_select_button: boolean;
  shop_select_page_url?: string;
  shop_select_description?: string;
  shop_select_button_copy?: string;
  bundle?: {
    left?: CmsProductBase;
    right?: CmsProductBase;
  };
}

export interface CmsProductFeature {
  uuid: string;
  feature: {
    uuid: string;
  };
  selected_option?: {
    uuid: string;
    feature_uuid: string;
    name?: string;
    sub_item?: string;
    legal_copy?: string;
    image_url?: string;
    alt_tag?: string;
  };
}

export interface CmsChartCarouselSection {
  uuid: string;
  filter_button_copy: string;
  category_title: string;
  product_kind: {
    uuid: string;
  };
}

export interface CmsSection {
  uuid: string;
  name: string;
  font?: string;
  font_color?: string;
  mobile_title_color?: string;
  mobile_title_row_color?: string;
  collapsed: boolean;
  show_product_overview: boolean;
  product_overview_title_copy?: string;
  subsections: CmsSubSection[];
}

export interface CmsSubSection {
  uuid: string;
  name?: string;
  font?: string;
  font_color?: string;
  mobile_title_color?: string;
  mobile_title_row_color?: string;
  features: CmsFeature[];
}

export interface CmsFeature {
  uuid: string;
  feature: {
    uuid: string;
    icon_url?: string;
    alt_tag?: string;
    name: string;
    show_tooltip: boolean;
    tooltip_description?: string;
    tooltip_title?: string;
    legal_copy?: string;
  };
}

export interface CmsStatSection {
  uuid: string;
  title: string;
  title_font?: string;
  title_text_color?: string;
  description: string;
  description_font?: string;
  description_text_color?: string;
  image_url?: string;
  image_alt?: string;
}

export interface CmsFooter {
  uuid: string;
  image_url: string;
  image_alt?: string;
}

export interface CmsLabel {
  uuid: string;
  name: string;
  text: string;
}

export async function fetchChartData(
  apiUrl: string,
  experienceId: string,
): Promise<CmsChartData> {
  const response = await axios.get(
    `${apiUrl}/external/comparison_chart_partners/${experienceId}`,
  );
  return response.data;
}
